/**
 * Matcher for Time and Day targeting
 * Ported from [js/shared/time_and_day_interval.js@20fa01b889](https://github.com/optimizely/optimizely/blob/20fa01b889c542af72cec8ae354dd6533ae03a43/src/www/js/shared/time_and_day_interval.js)
 *
 * @module
 */
var _ = require('optimizely-client-fn');

var DELIM = '_';

var DAYS_DELIM = ',';

var TIME_DELIM = ':';

/**
 * Serializes a time interval
 *
 * start_time and end_time must be in 24 hour 'HH:MM' format
 * @param data { { start_time: string, end_time: string, days: array.<string> } }
 * @return {string} ex: '10:00_15:00_monday,tuesday,wednesday'
 */
function serialize(data:any): string {
  return (
    data.start_time +
    DELIM +
    data.end_time +
    DELIM +
    data.days.join(DAYS_DELIM)
  );
}

/**
 * Deserializes a time interval
 *
 * @param serialized {string} ex: '10:00_15:00_monday,tuesday,wednesday'
 * @return { { start_time: string, end_time: string, days: Array } }
 * @private
 */
function deserialize(serialized:string): any {
  var parts = serialized.split(DELIM);
  if (parts.length !== 3) {
    throw new Error('Invalid time and day string ' + serialized);
  }
  var days = parts[2].split(DAYS_DELIM);

  return {
    start_time: parts[0],
    end_time: parts[1],
    days: days
  };
}

/**
 * Takes a 24h time string 'HH:MM' and converts it to minutes
 *
 * @param {string} timeStr
 * @return {number}
 * @private
 */
function timeStringToMinutes(timeStr:string): number {
  var parts = timeStr.split(TIME_DELIM);
  if (parts.length !== 2) {
    throw new Error('optly.timeAndDayInterval.timeStringToMinutes: Invalid time string ' + timeStr);
  }

  return (parseInt(parts[0], 10) * 60) + (parseInt(parts[1], 10));
}

/**
 * Tests whether the supplied date falls within the given interval
 * Uses local time
 *
 * Note: does not take into account seconds, so 1:00:30pm is equivalent
 * to 1:00pm in the comparison.
 *
 * @param intervalStr {string} serialized interval string
 * @param currentDate {Date}
 * @return {boolean}
 */
exports.test = function(intervalStr:string, currentDate:Date): boolean {
  var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  var interval = deserialize(intervalStr);
  var startTime = timeStringToMinutes(interval.start_time);
  var endTime = timeStringToMinutes(interval.end_time);
  var currentTime = (currentDate.getHours() * 60) + currentDate.getMinutes();
  var currentDay = days[currentDate.getDay()];

  return (
    currentTime >= startTime &&
    currentTime <= endTime &&
    _.includes(interval.days, currentDay)
  );
};

if (__TEST__) {
  exports.deserialize = deserialize;
  exports.serialize = serialize;
  exports.timeStringToMinutes = timeStringToMinutes;
}
